import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.gstechnovos.jexonplastech.components.SectionTitle
import org.gstechnovos.jexonplastech.components.ServiceCard
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Service
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ServiceSection() {
    Box(
        modifier = Modifier.id(Section.Service.id).maxWidth(SECTION_WIDTH.px).padding(topBottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        ServiceContent()
    }
}

@Composable
fun ServiceContent() {
    val breakPoint = LocalBreakpoint.current

    Column(modifier = Modifier.fillMaxWidth(if (breakPoint >= Breakpoint.MD) 100.percent else 90.percent),
        horizontalAlignment = Alignment.CenterHorizontally) {
        SectionTitle(
            modifier = Modifier.fillMaxWidth().margin(bottom = 20.px),
            section = Section.Service,
            alignment = Alignment.CenterHorizontally
        )

        SimpleGrid(numColumns = numColumns(base = 1, sm = 2,md = 3)) {
            Service.entries.forEach { service -> ServiceCard(service = service) }
        }
    }
}